import { PolicyComponentDetailsState } from "@idw-types/state/policy-component-details";
import { getPolicyComponentDetailsState } from "@redux/selectors/root-selectors";
import { createSelector } from "reselect";

export const getPolicyComponentDetailsDataState = createSelector(getPolicyComponentDetailsState, (state: PolicyComponentDetailsState) => {
    return {
        isLoadingPolicyComponentDetails: state.policyComponentDetails.isLoading,
        policyComponentDetails: state.policyComponentDetails.policyComponent,
        isLoadingAssociatedPolicies: state.associatedPolicies.isLoading,
        associatedPolicies: state.associatedPolicies.associatedPolicies
    };
});